var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubcriptionCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.96875 12.3336C0.96875 9.11326 2.24801 6.02486 4.5251 3.74776C6.8022 1.47067 9.8906 0.191406 13.1109 0.191406C16.3312 0.191406 19.4196 1.47067 21.6967 3.74776C23.9738 6.02486 25.2531 9.11326 25.2531 12.3336C25.2531 15.5539 23.9738 18.6423 21.6967 20.9194C19.4196 23.1965 16.3312 24.4757 13.1109 24.4757C9.8906 24.4757 6.8022 23.1965 4.5251 20.9194C2.24801 18.6423 0.96875 15.5539 0.96875 12.3336ZM12.418 17.5304L19.4086 8.79129L18.1458 7.78106L12.1849 15.2299L7.96263 11.7119L6.9265 12.9552L12.418 17.5304Z",
    fill: "#7EC242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcriptionCheck);
export default __webpack_public_path__ + "static/media/subcriptionCheck.b5c471769322b22cef1e3bb607c4e5ca.svg";
export { ForwardRef as ReactComponent };